import Serials from "../Components/Kays/Serials";
import ApiKeys from "../Components/Kays/ApiKeys";
import { Typography } from "@mui/material";
import useContentHook from "../hooks/useContentHook";
const Keys = () => {
    const { getContentText } = useContentHook();
  return (
    <div>
      <Typography
        sx={textStyle} >
          {/*  get content */}
      {  getContentText("api-keys")}
      </Typography>
      {/*  in this we render keys that we get from api  */}
      <ApiKeys />
      <Typography
        sx={textStyle} >
      {  getContentText("software-keys")}
      </Typography>
      {/*   get Serials keys */}
      <Serials />
    </div>
  );
};

export default Keys;

//  update style 
const textStyle= { fontWeight: 800, fontSize: "2.5rem", color: "primary.main"  }